import {
  createPrelaunchLessonDescriptions,
  editPublicPrelaunchLessonDescriptionDetail,
  getPrelaunchLessonDescriptionDetailByUniqueId,
} from '../../../../api/prelaunchOrganizationFormsApi'
import LessonDescriptionForm from '../../../../components/common/lesson-description-form'
import { convertLessonDescriptionToFormValues } from '../../../../helpers/prelaunch-organization-helper'
import translate from '../../../../i18n'
import { PrelaunchLessonDescriptionFormValues } from '../../../prelaunch-organization-forms-container/share-types'
import { PageHeader } from '@ant-design/pro-components'
import { notification, Space } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

const prelaunchLessonDescriptionForm = () => {
  const navigate = useNavigate()
  const params = useParams()
  const [uniqueId] = useState<string | undefined>(params?.uniqueId)
  const [organizationName] = useState<string | undefined>(params?.organizationName)
  const [lessonDescriptionId] = useState<string | undefined>(params?.lessonDescriptionId)
  const { pathname } = useLocation()
  const isPublicEdit = pathname.endsWith('/edit')

  const [prelaunchLessonDescriptionFormData, setPrelaunchLessonDescriptionFormData] =
    useState<PrelaunchLessonDescriptionFormValues>()

  useEffect(() => {
    if (lessonDescriptionId && uniqueId) {
      getPrelaunchLessonDescriptionDetailByUniqueId(uniqueId, Number(lessonDescriptionId)).then(
        data => {
          setPrelaunchLessonDescriptionFormData(convertLessonDescriptionToFormValues(data))
        },
      )
    }
  }, [lessonDescriptionId, uniqueId])
  const onFinish = (values: PrelaunchLessonDescriptionFormValues) => {
    if (!uniqueId) {
      return
    }
    const request =
      lessonDescriptionId && isPublicEdit
        ? editPublicPrelaunchLessonDescriptionDetail(uniqueId, lessonDescriptionId, values)
        : createPrelaunchLessonDescriptions({
            ...values,
            uniqueId: uniqueId,
          })

    request
      .then(response => {
        if (response) {
          notification.success({
            title: isPublicEdit ? '修改课程模版成功' : translate('addLessonDescriptions.success'),
          })
          navigate(`/public/prelaunch-organization-form/${uniqueId}`)
        }
      })
      .catch(err => {
        notification.error({
          message: isPublicEdit ? '修改课程模版失败' : translate('addLessonDescriptions.error'),
          description: err?.message || translate('networkError'),
        })
      })
  }

  const onBack = () => {
    navigate(-1)
  }

  if (!uniqueId) {
    return null
  }

  return (
    <Space orientation="vertical" style={{ width: '100%' }}>
      <PageHeader
        className="site-page-header"
        onBack={onBack}
        title={organizationName}
        subTitle={translate('addLessonDescriptions')}
      />
      <LessonDescriptionForm
        isEdit={false}
        isPublicEdit={isPublicEdit}
        organizationUniqueId={uniqueId}
        formData={prelaunchLessonDescriptionFormData}
        onFinish={onFinish}
      />
    </Space>
  )
}

export default prelaunchLessonDescriptionForm
